module.exports = __webpack_public_path__ + "prod/1.42.2/img/basic.83522837.png";